import React, { useState } from "react";
import {
  materialRenderers,
  materialCells,
} from "@jsonforms/material-renderers";
import { JsonForms } from "@jsonforms/react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import primaryTheme from "../../../theme/theme";

export interface IDynamicFormProps {
  fieldsSchema: any;
  uiSchema: any;
  formData?: any;
  onFormDataChanged?: (data: any, error: any) => void;
  isReadOnly?: boolean;
}

export const DynamicForm = (props: IDynamicFormProps) => {
  const [formData, setFormData] = useState(props.formData);
  const [fieldsSchema, setFieldsSchema] = useState(props.fieldsSchema);
  const [uiSchema, setUiSchema] = useState(props.uiSchema);

  React.useEffect(() => {
    setFormData(props.formData);
    setFieldsSchema(props.fieldsSchema);
    setUiSchema(props.uiSchema);
  }, [props.formData, props.fieldsSchema, props.uiSchema]);

  // const customRenderer = [
  //   ...materialRenderers,
  //   {
  //     tester: materialArrayLayoutTester,
  //     renderer: MaterialArrayLayoutRenderer,
  //   },
  // ];
  const theme = createTheme({
    components: {
      MuiFormControl: {
        defaultProps: {
          variant: "outlined",
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: "outlined",
        },
      },
      MuiSelect: {
        defaultProps: {
          variant: "outlined",
        },
      },
    },
  });
  return (
    <ThemeProvider theme={primaryTheme}>
      <JsonForms
        schema={fieldsSchema}
        uischema={uiSchema}
        data={formData}
        renderers={materialRenderers}
        cells={materialCells}
        readonly={props.isReadOnly}
        onChange={({ data, _errors }: any) => {
          //console.log("--onchange--", data);
          if (JSON.stringify(data) !== JSON.stringify(formData)) {
            setFormData(data);
            props.onFormDataChanged && props.onFormDataChanged(data, _errors);
          }
        }}
      />
    </ThemeProvider>
  );
};
